import ActionSheetModal from '@/vue/modals/ActionSheet/ActionSheetModal';
import AlertModal from '@/vue/modals/Dialogs/AlertModal';
import ConfirmModal from '@/vue/modals/Dialogs/ConfirmModal';
import CustomConfirmModal from '@/vue/modals/Dialogs/CustomConfirmModal';
import LoginSettingsModal from '@/vue/modals/LoginSettings/LoginSettingsModal';
import NumPadModal from '@/vue/modals/Dialogs/NumPadModal';
import OnlineStatusModal from '@/vue/modals/OnlineStatus/OnlineStatusModal';
import PhotoSelectorModal from '@/vue/modals/PhotoSelector/PhotoSelectorModal';
import PinRequestModal from '@/vue/modals/PinRequest/PinRequestModal';
import PromptModal from '@/vue/modals/Dialogs/PromptModal';
import ProPointUpdateModal from '@/vue/modals/ProPointUpdate/ProPointUpdateModal';
import SwitchUserModal from '@/vue/modals/SwitchUser/SwitchUserModal';
import TimeErrorModal from '@/vue/modals/TimeError/TimeErrorModal';
import TimezoneErrorModal from '@/vue/modals/TimezoneError/TimezoneErrorModal';
import { MODAL_NAMES } from '@/vue/modals/MODAL_NAMES';

export const globalModals = {
    // Globally available modals.
    // This should only be modals that can be displayed on any app.
    // If the modal will only be used on epos or only on kitchen for example,
    // It should be in the directory appropriate to that screen.
    [MODAL_NAMES.ACTION_SHEET]: ActionSheetModal,
    [MODAL_NAMES.ALERT]: AlertModal,
    [MODAL_NAMES.CONFIRM]: ConfirmModal,
    [MODAL_NAMES.CUSTOM_CONFIRM]: CustomConfirmModal,
    [MODAL_NAMES.LOGIN_SETTINGS]: LoginSettingsModal,
    [MODAL_NAMES.NUM_PAD]: NumPadModal,
    [MODAL_NAMES.ONLINE_STATUS]: OnlineStatusModal,
    [MODAL_NAMES.PIN_REQUEST]: PinRequestModal,
    [MODAL_NAMES.PHOTO_SELECTOR]: PhotoSelectorModal,
    [MODAL_NAMES.PROMPT]: PromptModal,
    [MODAL_NAMES.PROPOINT_UPDATE]: ProPointUpdateModal,
    [MODAL_NAMES.SWITCH_USER]: SwitchUserModal,
    [MODAL_NAMES.TIME_ERROR]: TimeErrorModal,
    [MODAL_NAMES.TIMEZONE_ERROR]: TimezoneErrorModal,
};

/**
 * @param {App} vueApp
 */
export const registerGlobalModals = (vueApp) => {
    Object.keys(globalModals).forEach((componentName) => {
        vueApp.component(componentName, globalModals[componentName]);
    });
};
